import { SETTINGS_SECTION } from './constants'

/**
 * Legacy `/app/organization/users|invitations|migrations` → org directory settings modal.
 * @param {string} pathname
 * @param {string} url — `/app/organization`
 * @returns {{ section: string, settingsTab: string | null } | null}
 */
export function matchLegacyOrganizationPathToSettingsSection(pathname, url) {
  const usersBase = `${url}/users`
  if (pathname === usersBase || pathname.startsWith(`${usersBase}/`)) {
    return { section: SETTINGS_SECTION.orgDirectory, settingsTab: 'active_users' }
  }

  const invitationsBase = `${url}/invitations`
  if (pathname === invitationsBase || pathname.startsWith(`${invitationsBase}/`)) {
  // Standalone invite flows (e.g. agreement) stay on full-page routes.
    const rest = pathname.slice(invitationsBase.length + 1)
    const firstSegment = rest.split('/').filter(Boolean)[0] ?? null
    if (firstSegment === 'agreement' || firstSegment === 'new') {
      return null
    }
    return { section: SETTINGS_SECTION.orgDirectory, settingsTab: 'pending_users' }
  }

  const migrationsBase = `${url}/migrations`
  if (pathname === migrationsBase || pathname.startsWith(`${migrationsBase}/`)) {
    return { section: SETTINGS_SECTION.orgDirectory, settingsTab: 'migrating_users' }
  }

  return null
}
